import { Box, Flex, Text, Image, Badge } from "@chakra-ui/react";
import { useSeason } from "../../context/SeasonContext";

export default function AdvertSlotCardPrint({ slot }) {
  const { seasonLabel } = useSeason();

  const {
    business_name,
    qr_code_url,
    offer_title,
    status,
    category_name,
    category_color,
    category_icon,
    business_logo_url,
    redeem_token,
    token,
  } = slot || {};

  const finalToken = redeem_token || token || null;

  const normalizedStatus = (status || "").toLowerCase().trim();
  const isBranding = normalizedStatus === "branding";
  const isBooked = normalizedStatus === "booked";

  const Scissors = () => (
    <Text
      fontSize="xs"
      color="gray.500"
      position="absolute"
      top="2px"
      right="6px"
      pointerEvents="none"
    >
      ✂️
    </Text>
  );

// ⭐ BRANDING SLOT
if (isBranding) {
  return (
    <Box
      position="relative"
      border="2px dashed #e11d48"
      bg="white"
      rounded="md"
      p="1px"                 // ⭐ SAFE INNER PADDING
      height="192px"
      width="266px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Scissors />

      <Text fontSize="1rem" fontWeight="extrabold" noOfLines={1}>
        Postcode.Coupons
      </Text>

      <Flex
        align="center"
        justify="center"
        gap={3}
        mt={1}
        mb={1}
      >
        <Image
          src="/logo1024.png"
          alt="logo"
          height="48px"
          width="48px"
        />

        <Image
          src="/deliveredby.webp"
          alt="Delivered by Royal Mail"
          height="48px"
          width="48px"
        />
      </Flex>

      <Text
        fontSize="0.9rem"
        fontWeight="extrabold"
        color="red.700"
        letterSpacing="1px"
      >
        SCAN. SAVE. KEEP.
      </Text>

      <Text
        fontSize="0.55rem"
        fontWeight="bold"
        mt={1}
        opacity={0.9}
        noOfLines={1}
      >
        {seasonLabel}
      </Text>
    </Box>
  );
}

  // ⭐ EMPTY SLOT
  if (!isBooked) {
    return (
      <Box
        position="relative"
        border="2px dashed #e5e7eb"
        bg="white"
        rounded="md"
        p="1px"                 // ⭐ SAFE INNER PADDING
        height="192px"
        width="266px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Scissors />

        <Image
          src="https://vpmcjtzgamhnfyxarqoz.supabase.co/storage/v1/object/public/qr-codes/qr/default-home.png"
          height="48px"
          width="48px"
          mb={1}
        />

        <Text fontSize="sm" fontWeight="semibold" color="gray.700" noOfLines={1}>
          No coupon available
        </Text>

        <Text fontSize="xs" color="red.600" mt={1} fontWeight="bold" noOfLines={1}>
          Advertise here
        </Text>

        <Text fontSize="0.6rem" color="gray.400" mt={1} noOfLines={1}>
          {seasonLabel}
        </Text>
      </Box>
    );
  }

  // ⭐ BOOKED SLOT
  return (
    <Box
      position="relative"
      border="2px dashed #e11d48"
      bg="white"
      rounded="md"
      height="192px"
      width="266px"
      p="2px"                 // ⭐ SAFE INNER PADDING
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Scissors />

      <Flex
        bg="red.600"
        color="white"
        align="center"
        px={2}
        minH="24px"
        maxH="24px"
        rounded="md"
      >
        <Text fontSize="0.65rem" fontWeight="bold" noOfLines={1}>
          {business_name}
        </Text>
      </Flex>

      {category_name && (
        <Badge
          bg={category_color}
          color="white"
          px={2}
          py={0.5}
          rounded="md"
          fontSize="0.55rem"
          fontWeight="bold"
          mt={1}
          noOfLines={1}
        >
          {category_icon ? `${category_icon} ` : ""}
          {category_name}
        </Badge>
      )}

      <Flex direction="column" align="center" justify="center" mt={1} mb={1}>
        <Text
          fontSize="0.8rem"
          fontWeight="extrabold"
          textAlign="center"
          noOfLines={2}
        >
          ⭐ {offer_title}
        </Text>

        <Flex align="center" justify="center" gap={3} mt={1}>
          {business_logo_url ? (
            <Image
              src={business_logo_url}
              height="35px"
              width="35px"
              objectFit="cover"
              rounded="full"
            />
          ) : (
            <Flex
              height="35px"
              width="35px"
              rounded="full"
              bg="red.500"
              color="white"
              fontWeight="bold"
              align="center"
              justify="center"
              fontSize="0.9rem"
            >
              {business_name?.charAt(0).toUpperCase()}
            </Flex>
          )}

          {qr_code_url && finalToken && (
            <Image
              src={qr_code_url}
              height="80px"
              width="80px"
              border="2px solid #e11d48"
              rounded="md"
              bg="white"
              p={1}
            />
          )}
        </Flex>
      </Flex>

      <Text
        fontSize="0.7rem"
        color="red.600"
        fontWeight="extrabold"
        textAlign="center"
      >
        SCAN TO REDEEM
      </Text>

      <Text
        fontSize="0.5rem"
        color="gray.500"
        textAlign="center"
        noOfLines={1}
      >
        Valid in your postcode only
      </Text>
    </Box>
  );
}
